import ENDPOINT from 'constants/endPoint';
import { NEEDS_ACTION_REASON_LABELS } from 'constants/flightBooking';

// The "Cần xử lý" tile links to the tab alone; each reason line deep-links further, so a tile
// and the list it opens always count the same orders (api-contract.md, "GET /flight-dashboard":
// needsAction.byReason is keyed by exactly the list's own needsActionReason filter).
export const NEEDS_ACTION_LINK = `${ENDPOINT.MANAGER_FLIGHT_BOOKING}?tab=NEEDS_ACTION`;

export const getReasonLink = (reason) => `${NEEDS_ACTION_LINK}&needsActionReason=${reason}`;

// One row per reason with at least one order, in the label map's own order (PM: "render a reason
// only when its count is > 0, ordered by the label map"). total is not their sum (one order can
// wait for two reasons), so this list is informational, never a breakdown that must add up.
export const getDashboardReasonRows = (byReason = {}) => Object.keys(NEEDS_ACTION_REASON_LABELS)
  .filter((reason) => (byReason[reason] || 0) > 0)
  .map((reason) => ({
    reason,
    label: NEEDS_ACTION_REASON_LABELS[reason],
    count: byReason[reason],
    href: getReasonLink(reason),
  }));
